import { Modal, Skeleton } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useFetchSites } from "../../entities/api";
import { useHttp } from "../../hooks/useHttp";
import AddAndEditVenueForm from "./AddAndEditVenueForm";

const AddAndEditVenueModal = ({ venueId = null, handleCloseModal, handleSendRequest, okButtonLoading, openModal }) => {
  const { formatMessage } = useIntl();
  const { sport, organizationId } = useParams();
  const { loading, request, error, cleanError } = useHttp();
  const [venue, setVenue] = useState(null);
  const [formRef, setFormRef] = useState(null);
  const { data: siteList } = useFetchSites({ limit: 1000 }, openModal);

  const handleSetFormRef = (form) => setFormRef(form);

  const fetchVenue = useCallback(async () => {
    try {
      const res = await request({
        url: `/v1/${sport}/o/${organizationId}/venues/${venueId}`,
      });
      setVenue(res?.data?.[0] || null);
    } catch (e) {
      console.error(e);
    }
  }, [organizationId, sport, venueId]);

  useEffect(() => {
    if (venueId) {
      fetchVenue();
    }
  }, [fetchVenue, venueId]);

  return (
    <Modal
      width={700}
      open={openModal}
      closable={true}
      destroyOnClose={true}
      onCancel={handleCloseModal}
      title={formatMessage({
        id: !venueId ? "venue.add" : "venue.update",
      })}
      okText={formatMessage({
        id: !venueId ? "add" : "update",
      })}
      onOk={() => handleSendRequest(formRef)}
      okButtonProps={{ loading: okButtonLoading }}
    >
      {!venueId ? (
        <AddAndEditVenueForm handleSetFormRef={handleSetFormRef} siteList={siteList} />
      ) : venue ? (
        <AddAndEditVenueForm handleSetFormRef={handleSetFormRef} siteList={siteList} venue={venue} />
      ) : (
        <Skeleton />
      )}
    </Modal>
  );
};

export default AddAndEditVenueModal;
